import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                WinSCP Unleashed: The Definitive Guide to Secure File Transfers
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

                <img src="/graphics/images/winscp.webp" alt="Adobe PDF Tools" />

                <h2>Introduction</h2>
                <p>
                  When it comes to securely transferring files between your local machine and a remote server, WinSCP is one of the most trusted and user-friendly tools available. Whether you're a system administrator, a web developer, or someone managing cloud-hosted files, WinSCP simplifies file transfers with its intuitive interface and robust features. In this blog, we will explore everything you need to know about WinSCP, from its features to how you can use it effectively.
                </p>

                <h2>What is WinSCP?</h2>
                <p>
                  WinSCP (Windows Secure Copy) is a free, open-source SFTP, FTP, WebDAV, SCP, and Amazon S3 client for Windows. It allows secure file transfer between a local and remote computer using SSH (Secure Shell) protocols. It also comes with a powerful file manager that enables you to manipulate files on both ends conveniently.
                </p>
        <p>WinSCP is particularly popular among web developers, IT professionals, and Linux administrators who require a secure, reliable, and user-friendly tool for transferring files over networks.</p>

                <h2>Features of WinSCP</h2>
        <p>Here are some key features that make WinSCP stand out:</p>

               <ol>
        <li>Secure File Transfer</li>
        <ol>
          <li>Supports secure protocols: SFTP, SCP, and FTPS.</li>
          <li>Transfers files securely using SSH encryption.</li>
          <li>Ensures data integrity and confidentiality.</li>
        </ol>
        
        <li>User-Friendly Interface</li>
        <ol>
          <li>Provides two GUI styles: Commander (Norton Commander-style) and Explorer (Windows Explorer-like).</li>
          <li>Drag-and-drop file transfers for ease of use.</li>
          <li>Quick navigation for files and folders.</li>
        </ol>
        
        <li>Integration with Windows</li>
        <ol>
          <li>Seamless integration with Windows File Explorer.</li>
          <li>Supports drag-and-drop, shortcuts, and jump lists.</li>
        </ol>
        
        <li>Powerful File Management</li>
        <ol>
          <li>Edit remote files directly using WinSCP's text editor or other editors (like Notepad++).</li>
          <li>Synchronize files and folders between your local and remote directories.</li>
          <li>Built-in support for scripting and task automation.</li>
        </ol>
        
        <li>Automation and Scripting</li>
        <ol>
          <li>Automate tasks with WinSCP scripts and command-line operations.</li>
          <li>Supports Windows Task Scheduler for automated transfers.</li>
          <li>Offers .NET assembly for programming integrations.</li>
        </ol>
        
        <li>Advanced Options</li>
        <ol>
          <li>Directory synchronization (both one-way and two-way sync).</li>
          <li>File encryption for additional security.</li>
          <li>Session saving for frequently used servers.</li>
          <li>Logging and detailed progress reports.</li>

        </ol>
        
         </ol>
         
         

                <h2>How to Install WinSCP</h2>
                <p>
                  Installing WinSCP on your Windows system is straightforward. Here’s how:
                </p>
        
        <ol>
        <li>Download WinSCP:
        <p>Visit the official website: https://winscp.net.</p>
        <img src="/graphics/images/winscp_link.webp" alt="winscp.net" />
        <p>Download the latest version of the installer.</p>
        <img src="/graphics/images/winscp_download.webp" alt="winscp download" />
        </li>
        
        <li>Run the Installer:
        <p>Launch the downloaded file.</p>
        <img src="/graphics/images/install1.webp" alt="winscp.net" />
        <p>Choose your preferred interface style (Commander or Explorer).</p>
        <img src="/graphics/images/install2.webp" alt="winscp download" />
        <p>Follow the setup instructions.</p>
        <img src="/graphics/images/install3.webp" alt="winscp download" />
        <img src="/graphics/images/install4.webp" alt="winscp download" />
        <img src="/graphics/images/install5.webp" alt="winscp download" />
        <img src="/graphics/images/install6.webp" alt="winscp download" />
        </li>
        
        <li>Launch WinSCP:
        <p>After installation, launch WinSCP and configure your first session.</p>
        <img src="/graphics/images/install7.webp" alt="winscp.net" />
        </li>
        </ol>
        
        <h2>How to Use WinSCP: Step-by-Step Guide</h2>
        <p>Once installed, you can start using WinSCP for secure file transfers. Follow these steps to connect and transfer files:</p>
        <ol>
          <li>Connect to a Remote Server
            <ol>
              <li>Open WinSCP.
              <img src="/graphics/images/winscpwindow.webp" alt="winscp.net" />
              </li>
              
              <li>Enter the connection details:
                <ol>
                  <li>File Protocol:SFTP, SCP, or FTP.</li>
                  <li>Host Name:IP address or domain of the remote server.</li>
                  <li>Port Number:Typically 22 for SFTP/SSH.</li>
                  <li>Username and Password:Credentials for the server.</li>
                </ol>
              </li>
              
              <li>Click Login to establish the connection.
              <img src="/graphics/images/install7.webp" alt="winscp.net" />
              </li>
            </ol>
          </li>
          <li>Transfer Files
          <ol>
            <li>Once connected, you’ll see two panels: the left panel shows your local files, and the right panel shows the remote server files.
              <img src="/graphics/images/transferwinscp.webp" alt="winscp.net" />
            </li>
            
            <li>Drag and drop files between the panels to upload or download.
              <img src="/graphics/images/transferwinscp1.webp" alt="winscp.net" />
            </li>
          </ol>
          </li>
          
          <li>Edit Files
            <ol>
              <li>Right-click any remote file and choose Edit.
                <img src="/graphics/images/editwinscp.webp" alt="winscp.net" />
              </li>
              
              <li>Make changes directly, and WinSCP will automatically upload the updated file back to the server.</li>
            </ol>
          </li>
          
          <li>Synchronize Directories
            <ol>
              <li>Go to Commands > Synchronize.</li>
              <li>Choose the direction (local to remote or vice versa) and sync files efficiently.</li>
            </ol>
          </li>
          
          <li>Automate File Transfers
            <ol>
              <li>Create WinSCP scripts to automate repetitive tasks:
              open sftp://username:password@hostname 
              <br/>

              put C:\local\file.txt /remote/directory/ <br/>

              exit</li>
              
              <li>Save the script as a .bat file and schedule it using the Windows Task Scheduler.</li>
            </ol>
          </li>
        </ol>
        
        <h2>Benefits of Using WinSCP</h2>
        <ol>
          <li>Security:Provides end-to-end encryption for file transfers.</li>
          <li>Reliability:Robust and proven tool used by professionals worldwide.</li>
          <li>Free and Open Source:No cost and constantly updated.</li>
          <li>Versatile:Supports multiple protocols and integrates with various tools.</li>
          <li>Automation-Friendly:Saves time with scripting capabilities.</li>
        </ol>
        
        <h2>WinSCP Alternatives</h2>
        <p>While WinSCP is an excellent tool, you might also consider these alternatives depending on your needs:</p>
        <ol>
          <li>FileZilla:Another popular FTP/SFTP client.</li>
          <li>Cyberduck:A user-friendly client for Windows and macOS.</li>
          <li>PuTTY:For SSH-based connections and file transfers.</li>
        </ol>

                
               
              </div>
            </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
